/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CompetitionInfo from 'app/modules/cinemaRent/components/Competition';
import { BonusInfoWrapper } from './styles';

const propTypes = {
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  competitionEvents: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  fetchCompetitionContent: PropTypes.func.isRequired,
  getCompetitionEvents: PropTypes.func.isRequired
};

const defaultProps = {
  content: [],
  competitionEvents: []
};

const Competition = ({
  content,
  competitionEvents,
  fetchCompetitionContent,
  getCompetitionEvents
}) => {
  const [t] = useTranslation();

  useEffect(() => {
    fetchCompetitionContent();
    getCompetitionEvents();
  }, []);

  return (
    <BonusInfoWrapper>
      {content?.length > 0 && (
        <>
          <h1 className="bonus-info__title">{t('common.competitions')}</h1>
          <div className="container">
            <CompetitionInfo competitionList={content} eventList={competitionEvents} />
          </div>
        </>
      )}
    </BonusInfoWrapper>
  );
};

Competition.propTypes = propTypes;
Competition.defaultProps = defaultProps;

export default Competition;
